export enum actionTypes {
    SET_CONNECTED = 'SOCKET:CONNECTED:SET',
    SET_CONNECTION = 'SOCKET:CONNECTION:SET',
    UNSET_CONNECTION = 'SOCKET:CONNECTION:UNSET'
}
